import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { withRouter } from 'react-router';
import Input from '../../components/Input';
import Select from '../../components/Select';
import DateTimePicker from '../../components/DateTimePicker';

const mapStateToProps = (state) => {
  return {
    values: getFormValues('company_segments.details')(state),
  };
};

@reduxForm({
  form: 'company_segments.details',
  enableReinitialize: true,
})
@subscribe(Localization, 'localization')
@connect(mapStateToProps)
@withRouter
class EditCompanySegmentForm extends Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidMount() {}

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <Field
          name='name'
          component={Input}
          label={__('edit-company-segments-form.name')}
        />
        <Field
          name='abbreviation'
          component={Input}
          label={__('edit-company-segments-form.abbreviation')}
        />
      </Form>
    );
  }
}

export default EditCompanySegmentForm;
